import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useTranslation } from "react-i18next";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import Button from "@mui/material/Button";

const BannerEditorConfirmation = ({
    showConfirmation,
    handleCancel,
    handleProceed,
}) => {
    const { t } = useTranslation();
    return (
        <Dialog
            open={showConfirmation}
            onClose={handleCancel}
            className="delete-modalTemp delete-modal"
            aria-labelledby="form-dialog-title"
            overlayStyle={{ backgroundColor: "transparent" }}>
            <DialogContent>
                <div className="delete-modalheading">
                    <span>{"Switch Size"}</span>
                </div>
                <div className="delete-modalSubHeading">
                    You will be switched to new
                    <span className="DeleteOnly">{" size. "}</span>
                    Are you sure?
                </div>
                <div className="delete-modalContent"></div>
            </DialogContent>
            <DialogActions className="delete-actionsTemp">
                <Button onClick={handleCancel} color="primary" className="no-btn">
                    CANCEL
                </Button>
                <Button
                    onClick={() => {
                        handleProceed();
                    }}
                    type="submit"
                    className="btn btn-primary"
                    autoFocus
                >
                    PROCEED
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BannerEditorConfirmation;
